import { Button, Modal, ModalFooter, ModalHeader, ModalMain, Stack } from '@sixfold/common-ui';

interface DeleteConfirmationModalProps {
  open: boolean;
  onToggle: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
}

export function DeleteConfirmationModal({ open, onToggle, onConfirm, isDeleting }: DeleteConfirmationModalProps) {
  return (
    <Modal
      trigger={
        <Button kind="danger" iconStart="small-cross">
          Delete
        </Button>
      }
      open={open}
      onToggle={onToggle}>
      <ModalHeader title="Delete Webhook Subscription" />
      <ModalMain>
        <p>Are you sure you want to delete this webhook subscription?</p>
      </ModalMain>
      <ModalFooter>
        <Stack justifyContent="end" gap="small">
          <Button kind="subtle" onClick={onToggle} disabled={isDeleting}>
            Cancel
          </Button>
          <Button kind="danger" onClick={onConfirm} disabled={isDeleting} loading={isDeleting}>
            Delete
          </Button>
        </Stack>
      </ModalFooter>
    </Modal>
  );
}
